import { mapActions, mapGetters, mapMutations } from "vuex";
import { email, maxLength, minLength, required, sameAs } from "vuelidate/lib/validators";

export default {
    name: "not-leave-page",
    data() {
        return {
            payload: {
                name: "",
                phone: "",
            },
            validationErrors: {},
        };
    },
    validations: {
        payload: {
            phone: {
                required,
                minLength: minLength(19),
            },
            name: {
                required,
                minLength: minLength(3),
                maxLength: maxLength(20),
            },
        },
    },

    components: {},
    computed: {
        ...mapGetters({}),
        nameErrors() {
            let error = [];
            if (!this.$v.payload.name.$dirty) {
                return error;
            }
            if (!this.$v.payload.name.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.name.minLength) {
                error.push(this.$t("validationMin") + " 3");
            }
            if (!this.$v.payload.name.maxLength) {
                error.push(this.$t("validationMax") + " 20");
            }
            if (this.validationErrors.name) {
                this.validationErrors.name.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        phoneErrors() {
            let error = [];
            if (!this.$v.payload.phone.$dirty) {
                return error;
            }
            if (!this.$v.payload.phone.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.phone.minLength) {
                error.push(this.$t("validationMin") + " 12");
            }
            if (this.validationErrors.phone) {
                this.validationErrors.phone.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
    },
    methods: {
        ...mapActions({
            fetchDataFromPopup: "articles/SEND_DATA_FROM_POPUPS",
        }),
        ...mapMutations({
            changeShowNotLeavePopup: "setting/SHOW_NOT_LEAVE_POPUP",
        }),
        isLetter(event) {
            var key = event.keyCode || event.which;
            key = String.fromCharCode(key);

            var regex = /^[A-Za-zА-Яа-яЁёЄєІіЇї \s]+$/;
            if (!regex.test(key)) {
                event.preventDefault();
                return false;
            }
        },
        submit() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                let data = {};
                data.phone = this.payload.phone;
                data.name = this.payload.name;
                data.type = "did_not_find";

                this.fetchDataFromPopup(data).then(() => {
                    this.changeShowNotLeavePopup(false);
                });

                // this.fastBuy(obj)
                //   .then(() => {
                //     this.$toasted.success(this.$t('successCreateFastBuy'));
                //     this.changeFastBuy(false, {
                //       show: false,
                //     });
                //   }).catch(error => {
                //   if (error.response.status === 418) {
                //     this.$toasted.error(error.response.data.data.error.message);
                //   }
                //   if (error.response.status === 422) {
                //     this.$toasted.error(error.response.data.message);
                //   }
                // });
            }
        },
    },
    destroyed() {},
};
